import { ElementRef,Directive,HostListener } from '@angular/core';

@Directive({
  selector: '[appRestirctNumberScroll]'
})
export class RestirctNumberScrollDirective {

  constructor(private el: ElementRef) { }
  @HostListener('wheel', ['$event'])
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const allowedCharacters = /^[0-9]*$/; // Regex to allow only numbers
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }
  // @HostListener('input', ['$event'])
  // onInput(event: any) {
  //   const input = this.el.nativeElement as HTMLInputElement;
  //   const inputValue = input.value.replace(/\D/g, ''); // Remove non-numeric characters
  //   if (inputValue.length > 10) {
  //     input.value = inputValue.slice(0, 10); // Limit to 10 digits
  //   }
  // }

  // onKeyPress(event: KeyboardEvent) {
  //   const allowedCharacters = /^[0-9]*$/; // Regex to allow only numbers
  //   const inputChar = String.fromCharCode(event.charCode);
  //   if (!allowedCharacters.test(inputChar)) {
  //     event.preventDefault();
  //   }
  // }

}
